import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import ProfileIcon from './ProfileIcon';
import Timer from './Timer';

function Header({ onSubmit, onSaveDraft, onBack, selectedQuestion, savingDraft = false, onFeedback }) {
  return (
    <header className="header">
      <div className="header-left">
        {onBack && (
          <button className="back-btn" onClick={onBack} title="Back to Challenges">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
          </button>
        )}
        <Link to="/" className="logo">
          <span className="logo-icon">◈</span>
          <span className="logo-text">SystemCraft_</span>
        </Link>
        <Link to="/" className="challenges-link">
          All Challenges
        </Link>
      </div>

      <div className="header-right">
        <Timer />
        {onFeedback && (
          <button className="btn btn-feedback" onClick={onFeedback} title="Share Feedback">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            Feedback
          </button>
        )}
        <button
          className={`btn btn-secondary ${savingDraft ? 'saving' : ''}`}
          onClick={onSaveDraft}
          disabled={savingDraft}
          title="Save Draft (Ctrl+S)"
        >
          {savingDraft ? (
            <>
              <span className="btn-spinner"></span>
              Saving...
            </>
          ) : (
            'Save Draft'
          )}
        </button>
        <button className="btn btn-primary" onClick={onSubmit}>
          Submit Design
        </button>
        <ProfileIcon />
      </div>
    </header>
  );
}

export default Header;
